import { render, staticRenderFns } from "./releaseArticle.vue?vue&type=template&id=63e67176&scoped=true"
import script from "./releaseArticle.vue?vue&type=script&lang=js"
export * from "./releaseArticle.vue?vue&type=script&lang=js"
import style0 from "./releaseArticle.vue?vue&type=style&index=0&id=63e67176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e67176",
  null
  
)

export default component.exports